// extracted by mini-css-extract-plugin
export default {"customizedTextAreaContainer":"CustomizedTextArea_customizedTextAreaContainer__DTWOm"};